/*
 * Copyright © 2018 Aram Meem Company Limited.  All Rights Reserved.
 */

import * as React from 'react';
import i18n, { currentLocale } from '../getText';
import {checkMobile} from '../helpers';

export class FooterWithLinks extends React.Component<any, any> {

  private nameLogo: string = 'logo';
  private appleStoreLink: string = 'https://itunes.apple.com/app/id1196302015?mt=8';
  private googlePlayLink: string = 'https://play.google.com/store/apps/details?id=com.arammeem.android.apps.toyou';

  render() {
    this.nameLogo = currentLocale === 'EN' ? 'logo' : 'arabic';

    return (
      <footer className="footer">
        <div className="container footer-container">

          <div className="logo">
            <p className="logo-text">{i18n.pgettext('Footer', 'Delivery by')}</p>
            <img src={`assets/${this.nameLogo}.png`}
                 srcSet={`assets/${this.nameLogo}@2x.png 2x, assets/${this.nameLogo}@3x.png 3x`}
                 height={43}
                 alt="ToYou"
                 className="logo-img"/>
          </div>

          {
            (checkMobile.iOS() || checkMobile.other()) && (
              <div className="app_link">
                <a target="_blank"
                   href={this.appleStoreLink}
                   className="btn btn-mobile btn-block">
                  <img src="assets/ios.svg"/>
                  <span className="btn-mobile_title">
                    {
                      !checkMobile.other() ? i18n.pgettext('Footer', 'Download for iOS') : 'iOS'
                    }
                  </span>
                </a>
                {
                  !checkMobile.other() && (
                    <p className="app_link-text">{i18n.pgettext('Footer', 'Also available on Google play')}</p>
                  )
                }
              </div>
            )
          }

          {
            (checkMobile.android() || checkMobile.other()) && (
              <div className="app_link">
                <a target="_blank"
                   href={this.googlePlayLink}
                   className="btn btn-mobile btn-block">
                  <img src="assets/android.svg"/>
                  <span className="btn-mobile_title">
                    {
                      !checkMobile.other() ? i18n.pgettext('Footer', 'Download for Android') : 'Android'
                    }
                  </span>
                </a>
                {
                  !checkMobile.other() && (
                    <p className="app_link-text">{i18n.pgettext('Footer', 'Also available on the Apple Store')}</p>
                  )
                }
              </div>
            )
          }


        </div>
      </footer>
    )
  }
}




// WEBPACK FOOTER //
// ./src/app/components/FooterWithLinks.tsx